import { Sparkles, Megaphone, Search } from 'lucide-react';
import { AppShell } from '@/components/layout/AppShell';
import { SectionPageEditor } from '@/components/admin/SectionPageEditor';
import type { SectionDef } from '@/components/admin/SectionPageEditor';
import { rxkModuleIcon, rxkModuleTitle, rxkNavGroups } from '../../nav';

// The Products listing page (pages/products/page.tsx) is almost entirely
// the live product grid — pulled from ProductsContext (stock, pricing,
// discounts), managed in Inventory → Products, not here. Only 5 static
// text keys exist around that grid: a small hero and a "3-Step Set" CTA
// banner. No images, no other sections. (The individual product DETAIL
// page at /products/:slug has its own ~40 text keys, but those are
// mostly UI chrome for reviews/Q&A/tabs, not marketing copy — left out
// of scope here.)
//
// The CTA banner's price and savings text are NOT editable here — they're
// pulled live from the real SET-3STEP bundle (core_products/routineSet),
// same source core_create_order prices from, so this banner can never show
// a stale ৳ figure that doesn't match what checkout actually charges.
const PRODUCTS_SECTIONS: SectionDef[] = [
  {
    key: 'hero',
    title: 'Hero',
    icon: Sparkles,
    note: 'The product grid itself is managed in Inventory → Products — this is just the page\'s own heading.',
    texts: [
      { key: 'products.hero.label', label: 'Eyebrow Label' },
      { key: 'products.hero.heading', label: 'Heading' },
      { key: 'products.hero.subtitle', label: 'Subtitle' },
    ],
  },
  {
    key: 'ctaBanner',
    title: '3-Step Set CTA Banner',
    icon: Megaphone,
    note: 'Price and savings shown here always match the real SET-3STEP bundle price — not editable as text.',
    texts: [
      { key: 'products.fullRoutine', label: 'Banner Label' },
      { key: 'products.hero.cta', label: 'Button' },
    ],
  },
  {
    key: 'seo',
    title: 'SEO',
    icon: Search,
    note: 'Shown in Google search results and social media link previews — not visible on the page itself.',
    texts: [
      { key: 'seo.products.title', label: 'Meta Title', long: true },
      { key: 'seo.products.description', label: 'Meta Description', long: true },
    ],
  },
];

export default function AdminProductsPage() {
  return (
    <AppShell moduleTitle={rxkModuleTitle} moduleIcon={rxkModuleIcon} navGroups={rxkNavGroups}>
      <SectionPageEditor pageKey="products" title="Products" sections={PRODUCTS_SECTIONS} />
    </AppShell>
  );
}
